/**
 * @(#)2020/3/30.
 * Range，用于输入数字区间
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import Range from "./yxRange";
import { IYxInputPropTypes } from "../IpropType/basePropType";
import PropTypes from "prop-types";

Range.propTypes = {
  // 公共参数类型
  ...IYxInputPropTypes,

  //输入框发生变化的回调，返回对象为一个数组
  onChange: PropTypes.func,

  /**
   * [[min1, max1], [min2, max2]]
    1.数组第一项/第二项为数组，数组可包含一个数字或两个数字.
    2.为一个数字时，该输入框的最小值和最大值都为该数字;
    3.为两个数字时，数组的第一个值和第二个值为第一个/第二个输入框的最小值和最大值
   */
  section: PropTypes.arrayOf(PropTypes.array),

  //第一个输入框的参数，继承antd的 Number组件 属性
  firstParams: PropTypes.object,

  //第二个输入框的参数，继承antd的 Number组件 属性
  secondParams: PropTypes.object,
};

Range.defaultProps = {
  rules: {
    max: "",
    required: false,
  },
  getFieldDecoratorParam: {},
  children: "",
};

export default Range;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/Range/index.js